/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {ComplaintAttachmentDtoModel} from './complaint-attachment-dto.model';

export class ComplaintDtoModel extends JSONable {

  uuid: string | undefined = undefined;

  parentUuid: string | undefined = undefined;

  orderUuid: string | undefined = undefined;

  message: string | undefined = undefined;

  createdAt: string | undefined = undefined;

  childComplaints: ComplaintDtoModel[] | undefined = undefined;

  attachments: ComplaintAttachmentDtoModel[] | undefined = undefined;

  ownedByTheCurrentUser: boolean | undefined = undefined;

  status: string | undefined = undefined;

  createdBy: string | undefined = undefined;
}
